import { render, staticRenderFns } from "./PhotoSelectorDrawer.vue?vue&type=template&id=08208330&scoped=true"
import script from "./PhotoSelectorDrawer.vue?vue&type=script&lang=js"
export * from "./PhotoSelectorDrawer.vue?vue&type=script&lang=js"
import style0 from "./PhotoSelectorDrawer.vue?vue&type=style&index=0&id=08208330&prod&lang=scss&scoped=true"
import style1 from "./PhotoSelectorDrawer.vue?vue&type=style&index=1&id=08208330&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08208330",
  null
  
)

export default component.exports